import { render, staticRenderFns } from "./FeaturedExams.vue?vue&type=template&id=e7ffffe6"
import script from "./FeaturedExams.vue?vue&type=script&lang=js"
export * from "./FeaturedExams.vue?vue&type=script&lang=js"
import style0 from "./FeaturedExams.vue?vue&type=style&index=0&id=e7ffffe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports